import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const UserIcon = ({ color = '#000', style = {}, size = 'sm', ...attr }) => {
  return (
    <svg {...iconSizes[size]} style={style} width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M14.9999 19V17C14.9999 13.134 11.8659 12 7.99994 12C4.13395 12 0.999939 13.134 0.999939 17V19M11.9999 5C11.9999 7.20914 10.2091 9 7.99994 9C5.7908 9 3.99994 7.20914 3.99994 5C3.99994 2.79086 5.7908 1 7.99994 1C10.2091 1 11.9999 2.79086 11.9999 5Z" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default UserIcon;
